import React, { useEffect, Fragment, useState, useRef } from 'react'
import { Button, Modal, Card, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, ClearSearchButton } from 'react-bootstrap-table2-toolkit';
import { LoadingComponent } from 'recupero-comunes';
import { serviceGetHitos, serviceGetImplicados, serviceGetInforme } from '../../api/api-consulta-hitos';
import { FaSearch } from "react-icons/fa";


const ConsultaContactoImplicados = ({ showModal, setShowModal, idCaso, idOrgCaso, tipoGestion }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([]);
    const [implicados, setImplicados] = useState([]);

    const [stateImplicado, setStateImplicado] = useState("");
    const [stateTodos, setStateTodos] = useState(false);

    const columnasTodos = [
        {
            /* hidden: stateImplicado !== "" ? false : true, */
            dataField: 'nombreImplicadoHito',
            text: 'Implicado',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'glosaHito',
            text: 'Modo Contacto',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.folioCarga, row.idImplicadoCasoHito)}
                />
            },
        }
    ];

    const columnasImplicado = [
        {
            dataField: 'glosaHito',
            text: 'Modo Contacto',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.folioCarga, row.idImplicadoCasoHito)}
                />
            },
        }
    ];

    useEffect(() => {
        if (showModal) getImplicados();
    }, [showModal])

    const handleImplicado = (value) => {
        setStateImplicado(value);
        if (value !== "") { setStateTodos(false); setData([]) }
    }

    const handleTodos = (value) => {
        setStateTodos(value);
        if (value) { setStateImplicado(""); setData([]) }
    }

    const handleClose = () => {
        setShowModal(false);
        setStateTodos(false);
        setStateImplicado("");
        setData([]);
    }

    const getImplicados = async () => {
        const query = Buffer.from(JSON.stringify({ idOrgCaso: idOrgCaso, idCaso: idCaso })).toString('base64');
        const response = await serviceGetImplicados(query);

        setImplicados(response);
        setLoading(false);
    }

    const handleInforme = async (folioCarga, implicado) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: implicado ? implicado : 0,
                idCompania: idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    const getContactoImplicados = async () => {
        let status = (stateImplicado !== "") ? "implicado" : (stateTodos) ? "todos" : "none";

        if (status !== "none") {
            setLoading(true);
            const query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicado: status === "implicado" ? stateImplicado : 999,
                idModoIngreso1: 238012,
                idModoIngreso2: 238011,
                tipoGestion: tipoGestion,
                ambitoGestion: null,
                responsableReasignado: false,
            })).toString('base64');

            const response = await serviceGetHitos(query);
            setData(response);
            setLoading(false);
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={handleClose} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        CONTACTOS IMPLICADOS / TERCEROS
                    </Card.Header>
                    <Card.Body style={{ padding: '10px 20px' }}>
                        <Row>
                            <Col md='3'>
                                <Form.Label>
                                    Seleccione Implicacdo
                                </Form.Label>
                                <Form.Select
                                    name='stateImplicado'
                                    onChange={(e) => handleImplicado(e.target.value)}
                                    value={stateImplicado}>

                                    <option value={""}>Seleccione</option>
                                    {implicados && implicados
                                        .map((i, index) => (<option key={index} value={i.IdImplicado}>{i.NombreImplicadoCmb}</option>))
                                    }
                                </Form.Select>
                            </Col>
                            <Col md='7'>
                                <Form.Check
                                    style={{ marginTop: '35px' }}
                                    name="stateTodos"
                                    label="Todos"
                                    checked={stateTodos}
                                    onChange={(e) => handleTodos(e.target.checked)}
                                />
                            </Col>
                            <Col md='2'>
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <span className='label mt-2'>Instancias</span>
                                    <br />
                                    <span className='label mt-2'>{data.length}</span>
                                </div>
                            </Col>
                        </Row>
                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                        <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                            <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>Volver</Button>
                            <Button style={{ width: '110px', color: 'white' }} variant='info' onClick={getContactoImplicados}>Buscar</Button>
                        </Col>

                        {(stateImplicado !== "" || stateTodos) &&
                            <div className='mt-3'>
                                <ToolkitProvider
                                    search
                                    bootstrap4
                                    keyField="idHito"
                                    data={data ? data : []}
                                    columns={stateTodos ? columnasTodos : columnasImplicado}
                                    defaultSorted={[{ dataField: 'Id', order: 'asc' }]}>
                                    {props =>
                                        <>
                                            <Row>
                                                <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                                    <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                                    <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                                </Col>
                                            </Row>
                                            <BootstrapTable
                                                {...props.baseProps}
                                                headerWrapperClasses="table-secondary"
                                                pagination={paginationFactory({ sizePerPage: 10})} 
                                                noDataIndication={
                                                    <div className="text-center">No hay registros encontrados.</div>
                                                }
                                            />
                                        </>
                                    }
                                </ToolkitProvider>
                            </div>
                        }
                    </Card.Body>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaContactoImplicados